import * as Sentry from "@sentry/react";
import { environment, variablesGlobales } from "./variables";

const dsn = variablesGlobales.glitchtipDsn;

export function initSentry() {
    Sentry.init({
        dsn,
        environment,
        enabled: Boolean(dsn) && environment !== "LOCAL",
        tracesSampleRate: environment === "PROD" ? 0.1 : 0.01,
        autoSessionTracking: false, // GlitchTip no soporta sessions
    });
}

// GlitchTip pisa el usuario completo en cada setUser(), así que acumulamos
// aquí lo que cada contexto (Auth, CreditUser) va conociendo del visitante.
let sentryUser = {};

export function mergeSentryUser(partial) {
    sentryUser = { ...sentryUser, ...partial };
    Sentry.setUser(sentryUser);
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
